export default __webpack_public_path__ + "assets/508afeef7e8298a27a6e7be6d4acfcfa.jpg";